import React from 'react'
import { Link } from 'react-router-dom'
import Style from '../details.module.css'

/** Connector versions plus the actions that hang off this tab. */
const MetaData = (props) => {
    const rows = [
        { label: props.sourceName, value: props.sourceVersion },
        { label: props.targetName, value: props.targetVersion },
        { label: 'Product Type', value: props.featureName }
    ]

    // Matches the shared SetupAction component: a type of 1 on either side means the
    // connector is set up in-app rather than by downloading an installer.
    const isHostedSetup = props.sourceType === 1 || props.targetType === 1

    const rememberSetup = () => {
        localStorage.setItem('setupConnectorId', props.connectorId)
        localStorage.setItem('setupInstanceId', props.instancesId)
    }

    const rememberConnector = () => {
        localStorage.setItem('configureConnectorId', props.connectorId)
        localStorage.setItem('configureInstanceId', props.instancesId)
    }

    return (
        <>
            <div className={`card-header ${Style.cardHeader}`}>
                <div className={Style.cardHeaderTitle}>
                    <span>Meta Data</span>
                </div>
            </div>

            <div className={`card-body ${Style.metaBody}`}>
                <dl className={Style.metaList}>
                    {rows.map((row) => (
                        <div className={Style.metaRow} key={row.label}>
                            <dt className={Style.metaLabel} title={row.label}>{row.label}</dt>
                            <dd className={Style.metaValue}>{row.value || '--'}</dd>
                        </div>
                    ))}
                </dl>

                <p className={Style.sectionTitle}>Other Options</p>

                <div className={Style.actionList}>
                    <Link
                        className={Style.actionItem}
                        to={{ pathname: '/Setup' }}
                        onClick={rememberSetup}
                    >
                        <span className={Style.actionIcon}>
                            <i className={isHostedSetup ? 'uil-sliders-v-alt' : 'uil-download-alt'} aria-hidden="true" />
                        </span>
                        <span className={Style.actionLabel}>
                            {isHostedSetup ? 'Setup' : 'Download Installers'}
                        </span>
                        <i className={`uil-angle-right ${Style.actionChevron}`} aria-hidden="true" />
                    </Link>

                    <Link
                        className={Style.actionItem}
                        to={{ pathname: '/configurations' }}
                        onClick={rememberConnector}
                    >
                        <span className={Style.actionIcon}><i className="uil-setting" aria-hidden="true" /></span>
                        <span className={Style.actionLabel}>Configuration</span>
                        <i className={`uil-angle-right ${Style.actionChevron}`} aria-hidden="true" />
                    </Link>

                    <button type="button" className={Style.actionItem} onClick={props.onViewToken}>
                        <span className={Style.actionIcon}><i className="uil-key-skeleton" aria-hidden="true" /></span>
                        <span className={Style.actionLabel}>View Token</span>
                        <i className={`uil-angle-right ${Style.actionChevron}`} aria-hidden="true" />
                    </button>
                </div>
            </div>
        </>
    )
}

export default MetaData
